var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31b52f347d18201377e3854c437a9ece.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/343f0f5d15a12a2f69430e5d9b07a184.js').default;
var scope_2 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8b4b82e05693d737125f16fe03f58144.js').default;
var scope_3 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    